import { bbAxios } from '@bb/session-manager';

import { MAX_RULE_STRENGTH } from '../config';
import {
  MODELS_ALL_FILTERED_ENDPOINT,
  MODELS_BASICS_ENDPOINT,
  MODELS_COUNT_TRAINING_ENDPOINT,
  MODELS_DOWNLOAD_JSON_FILE_ENDPOINT,
  MODELS_DOWNLOAD_TSV_FILE_ENDPOINT,
  MODELS_ENDPOINT,
  MODELS_MIGRATE_ENDPOINT,
  MODELS_RULES_ENDPOINT,
  MODELS_UNASSIGNED_TRAINING_ENDPOINT,
} from '../endpoints.config';
import { sortModels } from '../utils/modelDisplayUtils';

export async function GetModels() {
  const { data } = await bbAxios.get(MODELS_ENDPOINT);
  return sortModels(data);
}

export async function GetTrainingModelRules(id) {
  const { data } = await bbAxios.get(MODELS_RULES_ENDPOINT(id));
  return data;
}

export async function GetAllFilteredModels() {
  const { data } = await bbAxios.get(MODELS_ALL_FILTERED_ENDPOINT);
  return data;
}

export async function GetModelBasics(id) {
  const { data } = await bbAxios.get(MODELS_BASICS_ENDPOINT(id));
  return data;
}

export async function GetModelTrainingCount(id) {
  const { data } = await bbAxios.get(MODELS_COUNT_TRAINING_ENDPOINT(id));
  return data;
}

export async function CheckForUnassignedTrainingData(id) {
  const { data } = await bbAxios.get(MODELS_UNASSIGNED_TRAINING_ENDPOINT(id));
  return data;
}

export async function FixUnassignedTrainingData(id, ruleStrengthDivisor) {
  const { data } = await bbAxios.put(MODELS_UNASSIGNED_TRAINING_ENDPOINT(id), {
    ruleStrengthDivisor,
    ruleStrengthMax: MAX_RULE_STRENGTH,
  });
  return data;
}

export async function DownloadAsTsv(id, file) {
  const { data } = await bbAxios.get(
    `${MODELS_DOWNLOAD_TSV_FILE_ENDPOINT(id)}?file=${file}`,
    {
      responseType: 'blob',
    }
  );
  return data;
}

export async function DownloadAsJson(id, file) {
  const { data } = await bbAxios.get(
    `${MODELS_DOWNLOAD_JSON_FILE_ENDPOINT(id)}?file=${file}`,
    {
      responseType: 'blob',
    }
  );
  return data;
}

export async function MigrateToV2(playbookId) {
  const { data } = await bbAxios.post(MODELS_MIGRATE_ENDPOINT(playbookId));
  return data;
}
